const StatsChart = {
  init() {
    this.chart();
  },

  chart() {
    const chartEl = document.querySelector(".chart.animate");

    if (!chartEl) {
      return;
    }

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        const bars = entry.target.querySelectorAll(".chart-item__visual-inner");
        const count = entry.target.querySelectorAll("[data-count]");

        if (!entry.isIntersecting) {
          return;
        }

        // Counter
        setTimeout(() => {
          count.forEach(function (item, index) {
            setTimeout(() => {
              StatsChart.rollNumbers(item);
            }, index * 1000);
          });
        }, 500);

        // Bars
        bars.forEach(function (bar, idx) {
          bar.classList.add("grow");
          const barWidth = bar.getAttribute("data-length") + "%";
          const delay = idx;

          bar.style.maxWidth = barWidth;
          bar.style.animationDelay = delay + "s";
        });
      });
    });

    observer.observe(chartEl);
  },

  rollNumbers(item) {
    const countSpeed = 200;
    const countTo = item.getAttribute("data-count");

    let count = parseInt(item.innerText || 0);
    const time = Math.round(countTo / countSpeed);
    count += time;
    item.innerText = count;

    if (count >= countTo) {
      item.innerText = countTo;

      StatsChart.liveUpdate(item);
    } else {
      setTimeout(() => {
        StatsChart.rollNumbers(item);
      }, 1);
    }
  },

  liveUpdate(item) {
    const randomTime = Math.floor(Math.random() * 7000);

    setTimeout(() => {
      item.innerText = parseInt(item.innerText) + 1;

      StatsChart.liveUpdate(item);
    }, randomTime);
  },
};

export default StatsChart;
